"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantAlias = instanceOfVariantAlias;
exports.VariantAliasFromJSON = VariantAliasFromJSON;
exports.VariantAliasFromJSONTyped = VariantAliasFromJSONTyped;
exports.VariantAliasToJSON = VariantAliasToJSON;
exports.VariantAliasToJSONTyped = VariantAliasToJSONTyped;
/**
 * Check if a given object implements the VariantAlias interface.
 */
function instanceOfVariantAlias(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('variant' in value) || value['variant'] === undefined)
        return false;
    return true;
}
function VariantAliasFromJSON(json) {
    return VariantAliasFromJSONTyped(json, false);
}
function VariantAliasFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'variant': json['variant'],
    };
}
function VariantAliasToJSON(json) {
    return VariantAliasToJSONTyped(json, false);
}
function VariantAliasToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'variant': value['variant'],
    };
}
//# sourceMappingURL=variantAlias.js.map